/* eslint-disable @next/next/no-img-element */
import { URL_IMG } from '@/constants/ui'
import { Box } from '@mui/material'
// import Image from 'next/image'
import React from 'react'
import Marquee from 'react-fast-marquee'

export default function MarqueeImage() {
  return (
    <Marquee
      speed={20}
      gradient={false}
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        opacity: 0,
        pointerEvents: 'none',
        transition: 'opacity 0.3s ease-in-out',
      }}
    >
      {[1, 2, 3, 4, 5].map((item) => (
        <Box
          key={item}
          sx={{
            display: 'flex',
            gap: '0.5rem',
          }}
        >
          <img
            alt="logo-Hydra"
            src={URL_IMG + `home/logo-marquee.svg`}
            width={180}
            height={40}
            style={{
              height: '2.5rem',
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>
      ))}
    </Marquee>
  )
}
